// Error objects of type ItxErrorTO

export interface ApiServerError {
  description: string;
  key: string;
  causes?: ApiServerErrorCause[];
  params?: string[];
}

export interface ApiServerErrorCause {
  description: string;
  key: string;
  params?: string[];
}

export function isApiServerError(error: unknown): error is ApiServerError {
  return isDefined(error)
         && isDefined((error as ApiServerError).description)
         && isDefined((error as ApiServerError).key);
}
